import React from 'react';
import { Helmet } from 'react-helmet-async';
import PageHeader from '../components/PageHeader';

function Services() {
	return (
		<>
			<Helmet>
				<title>Services • Appex Connect Hub</title>
			</Helmet>
			<PageHeader
				title="Specialty Contracting Services"
				subtitle="Construction-focused programs, compliant messaging, and transparent communications."
			/>
			<section className="section">
				<div className="container two-col">
					<div>
						<h2>Core Offerings</h2>
				<div className="grid grid-3">
					<div className="card feature">
						<div className="icon-circle">
							<svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M6 18v-3h12v3" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round"/><path d="M9 10.5a3 3 0 0 1 6 0V15H9v-4.5Z" stroke="currentColor" strokeWidth="1.5"/><path d="M7 18h10" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round"/></svg>
						</div>
						<h3>Business Equipment Finance Leads</h3>
						<p className="helper">
							Demand generation for equipment and asset financing providers. Our programs focus on
							disclosure-driven journeys and explicit opt-in for compliant contact.
						</p>
					</div>
					<div className="card feature">
						<div className="icon-circle">
							<svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M5 5h14v14H5V5Z" stroke="currentColor" strokeWidth="1.5"/><path d="M8 9h8m-8 3h5" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round"/></svg>
						</div>
						<h3>Consumer Lending Introductions</h3>
						<p className="helper">
							We introduce consumers to third-party providers for personal, auto, and mortgage products.
							We do not make credit decisions and do not charge consumers for referrals.
						</p>
					</div>
					<div className="card feature">
						<div className="icon-circle">
							<svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M5 5h14v9H5V5Z" stroke="currentColor" strokeWidth="1.5"/><path d="M5 14 3 19h18l-2-5" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round"/><path d="M9 9h6" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round"/><path d="M12 5v9" stroke="currentColor" strokeWidth="1.5"/></svg>
						</div>
						<h3>Managed SMS Campaigns</h3>
						<p className="helper">
							A2P-compliant messaging with keyword controls (STOP/HELP), frequency disclosures,
							and opt-in capture stored with timestamp and user agent.
						</p>
					</div>
				</div>
				<div className="grid" style={{ marginTop: 18 }}>
					<div className="card" style={{ padding: 18 }}>
						<h3>Engagement & Reporting</h3>
						<p className="helper">Weekly performance snapshots, contact outcomes, and opt-out monitoring to ensure program health.</p>
					</div>
					<div className="card" style={{ padding: 18 }}>
						<h3>Content & Disclosures</h3>
						<p className="helper">We create clear, plain-language disclosures to minimize confusion and support compliance.</p>
					</div>
					<div className="card" style={{ padding: 18 }}>
						<h3>Field Services Coordination</h3>
						<p className="helper">Project update messaging (scheduling, arrivals, site readiness) aligned with TCPA-friendly scripts.</p>
					</div>
				</div>
					</div>
					<div className="img-frame fade-up">
						<img src="https://images.unsplash.com/photo-1469474968028-56623f02e42e?q=80&w=1600&auto=format&fit=crop" alt="Construction team collaborating on site" />
					</div>
				</div>
			</section>
		</>
	);
}

export default Services;


